export default __webpack_public_path__ + "static/media/slide6.4a4de803.jpg";